import React, { lazy } from 'react';
import { CreateRoot } from '../../assets/js/react';
const GenericPayment = lazy(() => import("../../assets/js/react/components/generic-payment/generic-payment"));
const locationElement = document?.getElementById('generic-payment');
const logoUrl = locationElement?.getAttribute('data-logo-url') || '';

CreateRoot('generic-payment', <GenericPayment logoUrl={logoUrl}/>);